import React, {Component} from 'react';


class Footer extends React.Component {
  render() {
return <div className="nk-footer container-fluid text-center">
                                    <div className="container wide-xl">
                                        <div className="nk-footer-wrap g-2">
                                            <div className="nk-footer-copyright"> &copy; 2023 Marunadan Malayalee.
                                            </div>
                                            <div className="nk-footer-links">
                                                <ul className="nav nav-sm">
                                                    <li className="nav-item"><a className="nav-link" href="#">Terms</a></li>
                                                    <li className="nav-item"><a className="nav-link" href="#">Privacy</a></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
    
    }
}
export default Footer;